import { faCircleNotch, faEye } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TimeLine from "components/TimeLine"
import { formatDate, formatPhoneNumber, getOrderSteps } from "helpers"
import _ from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import {
  getFlashAr,
  getInterLogAr,
  getMobiAr,
} from "services/shipping-events/calls"
import {
  addNoteToOrder,
  createRequest,
  getChannels,
  getQueues,
  getRequestsAR,
  getSupportRequestType,
} from "services/support/calls"
import jwt from "jsonwebtoken"

import { Navigation, Pagination, Scrollbar } from "swiper"

import { faNewspaper } from "@fortawesome/free-solid-svg-icons"
import toast from "components/Toast/Toast"
import moment from "moment"
import { getIcon } from "pages/Rastreio/constants"
import Select from "react-select"
import ChamadosModal from "./ChamadosModal"
import AddressForm from "./forms/AddressForm"
import DefaultForm from "./forms/DefaultForm"
import NoteForm from "./forms/NoteForm"

const DetalhesAtendimento = ({
  t,
  order,
  statuses,
  orderIndex,
  onFinished,
}) => {
  moment.locale("pt-br")
  const orderNoteRef = useRef(null)

  const { id } = useParams()
  const [isLoading, setLoading] = useState(false)
  const [isRequestLoading, setRequestLoading] = useState(false)
  const [currentOrder, setCurrentOrder] = useState(order)
  const [orderStatuses, setOrderStatuses] = useState({ steps: [], active: 0 })
  const [alert, setAlert] = useState(null)
  const [support, setSupport] = useState(null)
  const [timeLine, setTimeLine] = useState([])
  const [timeLineCards, setTimeLineCards] = useState(0)
  const [flashAr, setFlashAr] = useState({ loading: true })
  const [mobiAr, setMobiAr] = useState({ loading: true })
  const [interlogAr, setInterlogAr] = useState({ loading: true })
  const [showModal, setShowModal] = useState(false)
  const [showModalNota, setShowModalNota] = useState(false)
  const [openedOrder, setOpenedOrder] = useState(null)
  const [requests, setRequests] = useState([])
  const [novaSolicitacao, setNovaSolicitacao] = useState(false)
  const [selectedForm, setSelectedForm] = useState(<></>)
  const [activeRequest, setActiveRequest] = useState(null)
  const [closedRequestAnnotations, setClosedRequestAnnotations] = useState(null)

  const [canais, setCanais] = useState([])
  const [filas, setFilas] = useState([])

  const [queues, setQueues] = useState([])

  const channelRef = useRef()
  const filalRef = useRef()

  const [newSupportRequestType, setNewSupportRequestType] = useState(null)
  const [tipoChamado, setTipoChamado] = useState([])
  const [canalAtendimento, setCanalAtendimento] = useState([])
  const [filaAtendimento, setFilaAtendimento] = useState([])

  const getForms = tag => {
    const forms = {
      reenviar_cartao: (
        <NoteForm
          onSubmit={(text, note, file) =>
            createSupportRequest(text, "reenviar_cartao", file)
          }
          onCancel={() => {
            setNovaSolicitacao(false)
            setSupport(null)
            setSelectedForm(<></>)
          }}
        />
      ),
      alterar_endereco: (
        <AddressForm
          onSubmit={res =>
            createSupportRequest(
              res.newAddress,
              "alterar_endereco",
              res.file,
              res.sameAddress
            )
          }
          onCancel={() => {
            setNovaSolicitacao(false)
            setSupport(null)
            setSelectedForm(<></>)
          }}
          currentOrder={currentOrder}
        />
      ),
    }
    return (
      forms[tag] || (
        <DefaultForm
          onSubmit={(text, file) => createSupportRequest(text, tag, file)}
          onCancel={() => {
            setNovaSolicitacao(false)
            setSupport(null)
            setSelectedForm(<></>)
          }}
        />
      )
    )
  }

  let history = useHistory()

  useEffect(() => {
    setCurrentOrder(order)
    setOrderStatuses(getOrderSteps(statuses, order.status))
    timeLineBuilder(order, statuses)
    setFlashDigitalAr(order)
    setMobiDigitalAr(order)
    setInterlogDigitalAr(order)
    fetchChannels()
    fetchFilas()
    fetchSupportTypes()
    latest()
  }, [order, statuses])

  const getTypeOptionsValue = () => {
    if (
      typesOptions.filter(
        e =>
          e.canShow === true &&
          (e.shippingCompanyId === null ||
            e.shippingCompanyId === order.shippingCompanyId)
      ).length === 1
    ) {
      const sel = typesOptions.filter(
        e =>
          e.canShow === true &&
          (e.shippingCompanyId === null ||
            e.shippingCompanyId === order.shippingCompanyId)
      )[0]
      setQueues(sel.queues)
      setSelectedForm(sel.form)
      setSupport(sel.value)
      setTipoChamado(sel)
      getFilaAtendimentoValue(sel.queues)
    } else {
      filalRef.current = []
      setFilaAtendimento([])
      setTipoChamado([])
    }
  }

  const getCanalAtendimentoValue = () => {
    if (canalAtendimetoOptions.length === 1) {
      setCanalAtendimento(canalAtendimetoOptions[0])
      channelRef.current = canalAtendimetoOptions[0]
    } else {
      channelRef.current = []
      setCanalAtendimento([])
    }
  }

  const getFilaAtendimentoValue = queue => {
    if (
      filaAtendimetoOptions.filter(f => {
        return queue?.includes(f.value)
      })?.length === 1
    ) {
      const fila = filaAtendimetoOptions.filter(f => {
        return queue?.includes(f.value)
      })[0]
      setFilaAtendimento(fila)
      filalRef.current = fila
    } else {
      filalRef.current = []
      setFilaAtendimento([])
    }
  }

  const fetchChannels = async () => {
    try {
      const canais = await getChannels()
      setCanais(canais.filter(c => c.deletedAt === null))
    } catch (error) {
      console.log(error)
    }
  }

  const canalAtendimetoOptions = canais.map(canal => ({
    value: canal.id,
    label: canal.name,
  }))

  const fetchSupportTypes = async () => {
    const supTypes = await getSupportRequestType()
    setNewSupportRequestType(supTypes.filter(c => c.deletedAt === null))
  }

  const typesOptions = newSupportRequestType
    ? newSupportRequestType.map(sup => {
        const { queues, orderStatus, sameAddress } = JSON.parse(
          sup?.config || "{}"
        )
        return {
          value: sup.tag,
          label: sup.name,
          canShow: Array.isArray(orderStatus)
            ? orderStatus.includes(currentOrder.currentStatusId)
            : false,
          form: sup?.isAuto ? (
            <AddressForm
              onSubmit={res =>
                createSupportRequest(res.newAddress, sup.tag, res.sameAddress)
              }
              onCancel={() => {
                setNovaSolicitacao(false)
                setSupport(null)
                setSelectedForm(<></>)
              }}
              currentOrder={currentOrder}
              sameAddress={sameAddress}
            />
          ) : (
            getForms(sup.tag)
          ),
          queues: queues,
          shippingCompanyId: sup?.shippingCompanyId,
        }
      })
    : []

  const fetchFilas = async () => {
    try {
      const filas = await getQueues()
      setFilas(filas.filter(c => c.deletedAt === null))
    } catch (error) {
      console.log(error)
    }
  }

  const filaAtendimetoOptions = filas.map(canal => ({
    value: canal.id,
    label: canal.name,
  }))

  const latest = async () => {
    try {
      const { payload } = await getRequestsAR(order.id)
      setRequests(payload.supports)
      if (payload.supports?.closed?.length > 0) {
        const lastIsAuto =
          payload.supports?.closed
            .filter(c => c.currentQueueType.isAuto)
            .slice(-1)[0] || null
        const lastIsFraude =
          payload.supports?.closed
            .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
            .slice(-1)[0] || null
        const isFraude =
          payload.supports?.opened
            .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
            .slice(-1)[0] || null
        const dates = [lastIsAuto, lastIsFraude, isFraude]
          .sort((a, b) => {
            return moment(b?.createdAt, "YYYY-MM-DD HH:mm:ss").diff(
              a?.createdAt,
              "YYYY-MM-DD HH:mm:ss"
            )
          })
          .filter(a => a !== null)
        if (dates.length > 0) {
          const end = dates[0].annotations
          setClosedRequestAnnotations(end ? JSON.parse(end) : null)
        } else {
          setClosedRequestAnnotations(null)
        }
        // if (lastIsAuto?.length > 0 && isFraude?.length > 0) {
        //   const dateAuto = moment(
        //     lastIsAuto[lastIsAuto?.length - 1].createdAt,
        //     "YYYY-MM-DD HH:mm:ss"
        //   )
        //   const dateFraude = moment(
        //     isFraude[isFraude?.length - 1].createdAt,
        //     "YYYY-MM-DD HH:mm:ss"
        //   )
        //   if (dateAuto > dateFraude) {
        //     setClosedRequestAnnotations(
        //       lastIsAuto?.length > 0
        //         ? JSON.parse(lastIsAuto[lastIsAuto?.length - 1].annotations)
        //         : null
        //     )
        //   } else {
        //     setClosedRequestAnnotations(
        //       isFraude?.length > 0
        //         ? JSON.parse(isFraude[isFraude?.length - 1].annotations)
        //         : null
        //     )
        //   }
        // } else {
        //   if (isFraude?.length > 0) {
        //     setClosedRequestAnnotations(
        //       isFraude?.length > 0
        //         ? JSON.parse(isFraude[isFraude?.length - 1].annotations)
        //         : null
        //     )
        //   } else if (lastIsAuto?.length > 0) {
        //     setClosedRequestAnnotations(
        //       lastIsAuto?.length > 0
        //         ? JSON.parse(lastIsAuto[lastIsAuto?.length - 1].annotations)
        //         : null
        //     )
        //   } else {
        //     setClosedRequestAnnotations(null)
        //   }
        // }
      } else {
        const isFraude =
          payload.supports?.opened
            .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
            .slice(-1)[0] || null
        if (isFraude) {
          setClosedRequestAnnotations(
            isFraude ? JSON.parse(isFraude?.annotations) : null
          )
        } else {
          setClosedRequestAnnotations(null)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const setFlashDigitalAr = async order => {
    if (order.shippingCompany.name == "Flash" && order.currentStatusId == 6) {
      try {
        const digitalAr = await getFlashAr(order.shippingOrderCode)
        setFlashAr({
          status: true,
          base64: digitalAr,
          loading: false,
        })
      } catch (error) {
        setFlashAr({
          status: false,
          text: "Aguardando disponibilização do comprovante",
          loading: false,
        })
        console.log(error)
      }
    }
  }

  const setMobiDigitalAr = async order => {
    if (order.shippingCompany.name == "Mobi" && order.currentStatusId == 6) {
      try {
        const digitalAr = await getMobiAr(order.shippingOrderCode)
        setMobiAr({
          status: true,
          base64: digitalAr.comprovante_entrega,
          loading: false,
        })
      } catch (error) {
        setMobiAr({
          status: false,
          text: "Aguardando disponibilização do comprovante",
          loading: false,
        })
        console.log(error)
      }
    }
  }

  const setInterlogDigitalAr = async order => {
    if (
      order.shippingCompany.name == "InterLog" &&
      order.currentStatusId == 6
      //&& order.digitalAr == "Sem link"
    ) {
      try {
        const digitalAr = await getInterLogAr(order.shippingOrderCode)
        setInterlogAr({
          status: true,
          base64: digitalAr.base64,
          loading: false,
        })
      } catch (error) {
        setInterlogAr({
          status: false,
          text: "Aguardando disponibilização do comprovante",
          loading: false,
        })
        console.log(error)
      }
    }
  }

  const ErrorMessage = ({ e }) => {
    return (
      <div>
        <strong>{e.title}</strong>
        <div>{e.message}</div>
      </div>
    )
  }

  ErrorMessage.propTypes = {
    e: PropTypes.any,
  }

  const createSupportRequest = (
    annotations,
    supportName,
    file = null,
    sameAddress = false
  ) => {
    if (!channelRef.current?.value) {
      toast("warning", "Por favor selecione um canal de atendimento.", "")
      return
    }
    if (!filalRef.current?.value) {
      toast("warning", "Por favor selecione uma fila de atendimento.", "")
      return
    }
    setRequestLoading(true)
    createRequest(
      supportName,
      {
        supportId: id,
        orderId: currentOrder.id,
        courierId: currentOrder.shippingCompanyId,
        courierName: currentOrder?.shippingCompany?.name,
        shippingOrderCode: currentOrder.shippingOrderCode,
        annotations: annotations,
        channelId: channelRef.current.value,
        queueId: filalRef.current.value,
        sameAddress: sameAddress,
      },
      file
    )
      .then(() => {
        setAlert({
          type: "success",
          message: "Solicitação criada com sucesso",
        })
        // window.location.reload(true)
      })
      .catch(error => {
        const { response, message } = error
        if (response) {
          if (response?.data?.errors?.error?.code === 3000) {
            setAlert({
              message: (
                <ErrorMessage
                  e={{
                    title: "Erro",
                    message:
                      "Tente novamente, caso o erro persista entrar em contato com Administrador.",
                  }}
                />
              ),
              type: "danger",
            })
          } else {
            setAlert({
              message: response.data.errors.map((e, i) => (
                <ErrorMessage e={e} key={`err-${i}`} />
              )),
              type: "danger",
            })
          }
        } else {
          setAlert({
            message,
            type: "danger",
          })
        }
      })
      .finally(() => {
        setShowModal(false)
        setNovaSolicitacao(false)
        setSupport(null)
        setRequestLoading(false)
      })
  }

  const timeLineBuilder = (order, statuses) => {
    let list = []
    let lastPlaceInOrder = 1
    if (order?.status.length === 0) {
      statuses.forEach((el, idx) => {
        list.push({
          title: el.name,
          icon: getIcon(el.id),
          active: idx == statuses.length - 1 ? true : false,
          subclass: "text-muted",
        })
      })
      setTimeLine(list)
      setTimeLineCards(list.length < 12 ? list.length : 12)
      return
    }
    _.sortBy(order.status || [], ["occurredAt"])
      .filter(s => !s.shippingEvent?.deletedAt)
      .forEach((el, idx) => {
        if (el.statusId) {
          lastPlaceInOrder =
            el.status.placeInOrder == null
              ? lastPlaceInOrder
              : el.status.placeInOrder > lastPlaceInOrder
              ? el.status.placeInOrder
              : lastPlaceInOrder
          list.push({
            title: el.status.name,
            description:
              idx != -1 ? formatDate(el.occurredAt, "DD/MM/YYYY") : " ",
            icon: getIcon(el.statusId),
            active: idx == order?.status.length - 1 ? true : false,
            subclass: el.occurredAt ? "text-primary" : "text-muted",
          })
          if (!el.status.isLast && idx == order?.status.length - 1) {
            statuses.map(status => {
              if (status.placeInOrder > lastPlaceInOrder) {
                list.push({
                  title: status.name,
                  icon: getIcon(status.id),
                  subclass: "text-muted",
                })
              }
            })
          }
        } else {
          list.push({
            title: el.externalEventName,
            description:
              idx != -1 ? formatDate(el.occurredAt, "DD/MM/YYYY") : " ",
            icon: getIcon(el.statusId),
            active: false,
            subclass: "text-muted",
          })
        }
      })
    setTimeLine(list)
    setTimeLineCards(list.length < 12 ? list.length : 12)
    return
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <FontAwesomeIcon icon={faCircleNotch} spin size="2x" />
        <span className="ml-3"> Encerrando atendimento...</span>
      </div>
    )
  }

  const getLocalName = (rawInfo, status, shippingLocal) => {
    const _rawInfo = JSON.parse(rawInfo || "{}")
    if (Object.hasOwn(_rawInfo, "dtHrCriado")) {
      try {
        if (shippingLocal == "null - null") {
          shippingLocal = " "
        }
        // const _rawInfo = JSON.parse(rawInfo)

        const code = `${_rawInfo.codigo}_${_rawInfo.tipo}`
        if (
          _rawInfo.unidade.endereco &&
          [
            "LDI_00",
            "LDI_01",
            "LDI_02",
            "LDI_03",
            "LDI_14",
            "BDE_24",
            "BDR_24",
            "BDI_24",
            "BDR_54",
            "BDI_54",
            "BDE_54",
            "BDE_55",
            "BDR_55",
            "BDI_55",
            "BDE_58",
            "BDI_58",
            "BDR_58",
            "BDE_59",
            "BDI_59",
            "BDR_59",
          ].indexOf(code) >= 0
        ) {
          const endereco = _rawInfo.unidade.endereco

          return `${endereco.logradouro} - ${endereco.numero}, ${endereco.bairro} - ${endereco.cidade}/${endereco.uf}`
        }
      } catch (error) {}

      try {
        // const _rawInfo = JSON.parse(rawInfo)
        const transport = order.shippingCompany.name
        if (
          status.name == "Encaminhado para os Correios" &&
          transport == "InterLog"
        ) {
          return _rawInfo.codentregacorreio
        }
        if (
          status.name == "Encaminhado para os Correios" &&
          transport == "Flash"
        ) {
          const arCorreios = _rawInfo.numEncTer
            ? _rawInfo.numEncTer
            : "Sem numero"
          return arCorreios
        }

        if (status.name == "Entregue") {
          /*
          if (order.digitalAr && transport !== "Flash") {
            if (order.digitalAr == "Sem link") {
              if (transport == "Interlog" && interlogAr?.loading) {
                return (
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    spin
                    size="1x"
                    color="#000"
                  />
                )
              }

              if (interlogAr.base64) {
                return (
                  <a
                    style={{ display: "table-cell", color: "green" }}
                    href={interlogAr.base64}
                    target="_blank"
                  >
                    Ar Digital
                  </a>
                )
              }
              return interlogAr.text
            }
            return (
              <a
                style={{ display: "table-cell", color: "green" }}
                href={order.digitalAr}
                target="_blank"
              >
                Ar Digital
              </a>
            )
          }
          */

          if (transport == "Flash" && flashAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (transport == "Mobi" && mobiAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (transport == "InterLog" && interlogAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (transport == "Flash" && !flashAr?.loading) {
            if (flashAr.status) {
              const openInNewTab = url => {
                let win = window.open()
                win.document.write(
                  '<iframe src="' +
                    url +
                    '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
                )
              }
              return (
                <a
                  style={{ display: "table-cell", color: "green" }}
                  onClick={() => {
                    openInNewTab(`data:image/jpeg;base64,${flashAr.base64}`)
                  }}
                >
                  Assinatura do Recebedor
                </a>
              )
            } else {
              return flashAr.text
            }
          }

          if (transport == "Mobi" && !mobiAr?.loading) {
            if (mobiAr.status) {
              const openInNewTab = url => {
                let win = window.open()
                win.document.write(
                  '<iframe src="' +
                    url +
                    '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
                )
              }
              return (
                <a
                  style={{ display: "table-cell", color: "green" }}
                  onClick={() => {
                    openInNewTab(mobiAr.base64)
                  }}
                >
                  Assinatura do Recebedor
                </a>
              )
            } else {
              return mobiAr.text
            }
          }

          if (transport == "InterLog" && !interlogAr?.loading) {
            if (interlogAr.status) {
              const openInNewTab = url => {
                let win = window.open()
                win.document.write(
                  '<iframe src="' +
                    url +
                    '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
                )
              }
              return (
                <a
                  style={{ display: "table-cell", color: "green" }}
                  onClick={() => {
                    //openInNewTab(interlogAr.base64)
                    openInNewTab(`data:image/jpeg;base64,${interlogAr.base64}`)
                  }}
                >
                  Assinatura do Recebedor
                </a>
              )
            } else {
              return interlogAr.text
            }
          }
        }
      } catch (error) {}
      return shippingLocal || status?.name
    } else {
      try {
        if (shippingLocal == "null - null") {
          shippingLocal = " "
        }
        // const _rawInfo = JSON.parse(rawInfo)

        const code = `${_rawInfo.tipo}_${_rawInfo.status}`
        if (
          _rawInfo.endereco &&
          [
            "LDI_00",
            "LDI_01",
            "LDI_02",
            "LDI_03",
            "LDI_14",
            "BDE_24",
            "BDR_24",
            "BDI_24",
            "BDR_54",
            "BDI_54",
            "BDE_54",
            "BDE_55",
            "BDR_55",
            "BDI_55",
            "BDE_58",
            "BDI_58",
            "BDR_58",
            "BDE_59",
            "BDI_59",
            "BDR_59",
          ].indexOf(code) >= 0
        ) {
          const endereco = _rawInfo.endereco[0]

          return `${endereco.logradouro[0]} - ${endereco.numero[0]}, ${endereco.bairro[0]} - ${endereco.localidade[0]}/${endereco.uf[0]}`
        }
      } catch (error) {}

      try {
        // const _rawInfo = JSON.parse(rawInfo)
        const transport = order.shippingCompany.name
        if (
          status.name == "Encaminhado para os Correios" &&
          transport == "InterLog"
        ) {
          return _rawInfo.codentregacorreio
        }
        if (
          status.name == "Encaminhado para os Correios" &&
          transport == "Flash"
        ) {
          const arCorreios = _rawInfo.numEncTer
            ? _rawInfo.numEncTer
            : "Sem numero"
          return arCorreios
        }

        if (status.name == "Entregue") {
          /*
          if (order.digitalAr && transport !== "Flash") {
            if (order.digitalAr == "Sem link") {
              if (transport == "Interlog" && interlogAr?.loading) {
                return (
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    spin
                    size="1x"
                    color="#000"
                  />
                )
              }

              if (interlogAr.base64) {
                return (
                  <a
                    style={{ display: "table-cell", color: "green" }}
                    href={interlogAr.base64}
                    target="_blank"
                  >
                    Ar Digital
                  </a>
                )
              }
              return interlogAr.text
            }
            return (
              <a
                style={{ display: "table-cell", color: "green" }}
                href={order.digitalAr}
                target="_blank"
              >
                Ar Digital
              </a>
            )
          }
          */

          if (transport == "Flash" && flashAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (transport == "Mobi" && mobiAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (transport == "InterLog" && interlogAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (transport == "Flash" && !flashAr?.loading) {
            if (flashAr.status) {
              const openInNewTab = url => {
                let win = window.open()
                win.document.write(
                  '<iframe src="' +
                    url +
                    '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
                )
              }
              return (
                <a
                  style={{ display: "table-cell", color: "green" }}
                  onClick={() => {
                    openInNewTab(`data:image/jpeg;base64,${flashAr.base64}`)
                  }}
                >
                  Assinatura do Recebedor
                </a>
              )
            } else {
              return flashAr.text
            }
          }

          if (transport == "Mobi" && !mobiAr?.loading) {
            if (mobiAr.status) {
              const openInNewTab = url => {
                let win = window.open()
                win.document.write(
                  '<iframe src="' +
                    url +
                    '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
                )
              }
              return (
                <a
                  style={{ display: "table-cell", color: "green" }}
                  onClick={() => {
                    openInNewTab(mobiAr.base64)
                  }}
                >
                  Assinatura do Recebedor
                </a>
              )
            } else {
              return mobiAr.text
            }
          }

          if (transport == "InterLog" && !interlogAr?.loading) {
            if (interlogAr.status) {
              const openInNewTab = url => {
                let win = window.open()
                win.document.write(
                  '<iframe src="' +
                    url +
                    '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
                )
              }
              return (
                <a
                  style={{ display: "table-cell", color: "green" }}
                  onClick={() => {
                    //openInNewTab(interlogAr.base64)
                    openInNewTab(`data:image/jpeg;base64,${interlogAr.base64}`)
                  }}
                >
                  Assinatura do Recebedor
                </a>
              )
            } else {
              return interlogAr.text
            }
          }
        }
      } catch (error) {}
      return shippingLocal || status?.name
    }
  }

  const addNote = async e => {
    e.preventDefault()
    const orderNote = orderNoteRef.current.value
    try {
      await addNoteToOrder(openedOrder.id, orderNote)
      toast("success", "Nota adicionada com sucesso.")
    } catch (error) {
      console.log(error)
      toast("error", "Falha ao adicionar nota.")
    } finally {
      setOpenedOrder(null)
      setShowModalNota(false)
      setLoading(true)
      try {
        latest()
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
  }

  const isDisabled = () => {
    if (
      typesOptions.filter(
        e =>
          e.canShow === true &&
          (e.shippingCompanyId === null ||
            e.shippingCompanyId === order.shippingCompanyId)
      )?.length === 0
    ) {
      return true
    }
    // if (userChannel) {
    //   const canal = canais.filter(c => c?.id === userChannel)
    //   if (canal?.length === 0) {
    //     return true
    //   }
    //   if (
    //     canal[0]?.shippingModality &&
    //     canal[0]?.shippingModality !== order.shippingModality
    //   ) {
    //     return true
    //   }
    // }

    return false
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          {Number(orderIndex) === 0 && (
            <div
              className="d-flex flex-row-reverse"
              style={{ marginTop: 16, marginBottom: 16 }}
            >
              <Button
                color="cyan"
                className="mx-1"
                onClick={() => {
                  setNovaSolicitacao(true)
                  getTypeOptionsValue()
                  getCanalAtendimentoValue()
                }}
                disabled={isDisabled()}
              >
                Nova Solicitação
              </Button>
            </div>
          )}
        </Col>
      </Row>
      {alert && (
        <Row>
          <Col>
            <div className={`alert alert-${alert.type}`}>
              <div>{alert.message}</div>
              <div>{alert.reason}</div>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle>
                <h5 className="order-details__title">Informações gerais</h5>
              </CardTitle>
              <Table striped bordered hover size="xl">
                <thead>
                  <tr>
                    <th>AR</th>
                    <th>Empresa</th>
                    <th>Tipo de Emissão</th>
                    <th>Tipo Cartão</th>
                    <th>Transportadora</th>
                    <th>Estimativa de entrega</th>
                    <th>Endereço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{currentOrder.shippingOrderCode}</td>
                    <td>{currentOrder.nameCompany}</td>
                    <td>{currentOrder?.emissionType?.name}</td>
                    <td>{currentOrder?.product?.name}</td>
                    <td>{currentOrder?.shippingCompany?.name}</td>
                    <td>
                      {currentOrder.customerExpectedDeliveryAt
                        ? moment(
                            currentOrder.customerExpectedDeliveryAt,
                            "YYYY-MM-DD"
                          ).format("DD/MM/YYYY")
                        : "-"}
                    </td>
                    <td>
                      {closedRequestAnnotations
                        ? `${closedRequestAnnotations?.street}, ${
                            closedRequestAnnotations?.number || ""
                          }, ${closedRequestAnnotations?.complement || ""} - ${
                            closedRequestAnnotations?.neighborhood
                          } - ${closedRequestAnnotations?.city}, ${
                            closedRequestAnnotations?.state
                          } - ${closedRequestAnnotations?.postcode}`
                        : `${currentOrder?.shippingStreet}, ${
                            currentOrder?.shippingStreetNumber || ""
                          }, ${
                            currentOrder?.shippingAddressComplement || ""
                          } - ${currentOrder?.shippingNeighborhood} - ${
                            currentOrder?.shippingCity
                          }, ${currentOrder?.shippingState} - ${
                            currentOrder?.shippingPostcode
                          }`}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle>
                <h5 className="order-details__title">Acompanhamento</h5>
                <div className="order-details__content status-stepper">
                  <TimeLine
                    slidesperview={timeLineCards}
                    loop={false}
                    pagination={{
                      clickable: true,
                    }}
                    scrollbar={{ draggable: true }}
                    modules={[Pagination, Navigation, Scrollbar]}
                    className="owl-carousel owl-theme  navs-carousel events"
                    children={timeLine}
                  />
                </div>
              </CardTitle>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle>
                <h5 className="order-details__title">Eventos do Objeto</h5>
              </CardTitle>
              <Table striped bordered hover size="sm">
                <thead className="table-secondary">
                  <tr>
                    <th>Data do Evento</th>
                    <th>Título</th>
                    <th>Descrição</th>
                    <th>Detalhes</th>
                  </tr>
                </thead>
                <tbody>
                  {_.sortBy(order.status || [], ["occurredAt"])
                    .reverse()
                    .filter(s => !s.shippingEvent?.deletedAt)
                    .map(
                      (
                        {
                          status,
                          externalEventName,
                          shippingLocal,
                          occurredAt,
                          rawInfo,
                        },
                        index
                      ) => (
                        <tr key={index}>
                          <td>
                            {/* {moment(occurredAt?.split("T")[0]).format(
                              "DD/MM/YYYY"
                            )}{" "}
                            {moment(new Date(occurredAt)).format("HH:mm")} */}
                            {moment(occurredAt).format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>{status?.name}</td>
                          <td>{externalEventName || status?.name}</td>

                          <td>
                            {getLocalName(rawInfo, status, shippingLocal)}
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle>
                    <h5 className="order-details__title">
                      Chamados em atendimento
                    </h5>
                  </CardTitle>
                  <Table striped bordered hover size="sm">
                    <thead className="thead-light">
                      <tr>
                        <th>ID</th>
                        <th className="text-center">Tipos</th>
                        <th className="text-center">Atendente</th>
                        <th className="text-center">Dt. Criação</th>
                        <th className="text-center">Situação</th>
                        <th className="text-center">Opções</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requests?.opened?.length === 0 && (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Nenhum chamado encontrado
                          </td>
                        </tr>
                      )}
                      {requests?.opened?.map(request => (
                        <tr key={`request-${request.id}`}>
                          <td>#{request.id}</td>
                          <td className="text-center">{request.type.name}</td>
                          <td className="text-center">
                            {request.support?.employee?.name}
                          </td>
                          <td className="text-center">
                            {formatDate(request.createdAt, "DD/MM/YYYY")}
                          </td>
                          <td className="text-center">
                            {request.currentStepType?.name || "-"}
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-link"
                              id={`detail-${request.id}`}
                              onClick={() => {
                                setActiveRequest(request)
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                            <UncontrolledTooltip
                              placement="top"
                              target={`detail-${request.id}`}
                            >
                              Detalhes
                            </UncontrolledTooltip>
                            <button
                              className="btn btn-link"
                              id={`notes-${request.id}`}
                              onClick={() => {
                                setOpenedOrder(request)
                                setShowModalNota(true)
                              }}
                            >
                              <FontAwesomeIcon icon={faNewspaper} />
                            </button>
                            <UncontrolledTooltip
                              placement="top"
                              target={`notes-${request.id}`}
                            >
                              Notas
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle>
                    <h5 className="order-details__title">
                      Chamados encerrados
                    </h5>
                  </CardTitle>
                  <Table striped bordered hover size="sm">
                    <thead className="thead-light">
                      <tr>
                        <th>ID</th>
                        <th className="text-center">Tipos</th>

                        <th className="text-center">Atendente</th>
                        <th className="text-center">Dt. Criação</th>
                        <th className="text-center">Situação</th>
                        <th className="text-center">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requests?.closed?.length === 0 && (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Nenhum chamado encontrado
                          </td>
                        </tr>
                      )}
                      {requests?.closed?.map(request => (
                        <tr key={`request-${request.id}`}>
                          <td>#{request.id}</td>
                          <td className="text-center">{request.type.name}</td>

                          <td className="text-center">
                            {request.support?.employee?.name}
                          </td>
                          <td className="text-center">
                            {formatDate(request.createdAt, "DD/MM/YYYY")}
                          </td>
                          <td className="text-center">
                            {request.currentStepType?.name || "-"}
                          </td>
                          <td>
                            <button
                              className="btn btn-link"
                              onClick={() => {
                                setActiveRequest(request)
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal
        isOpen={showModalNota}
        centered
        size="xl"
        backdrop="static"
        toggle={() => {
          setShowModalNota(!showModalNota)
        }}
      >
        <ModalHeader>Adicionar Nota ao chamado #{openedOrder?.id}</ModalHeader>
        <ModalBody
          style={{ minHeight: 300 }}
          className="d-flex w-100 justify-content-center align-items-center"
        >
          <form onSubmit={addNote} className="w-100">
            <div className="form-group">
              <label>Nota:</label>
              <textarea className="form-control" rows="5" ref={orderNoteRef} />
            </div>
            <div className="form-group d-flex justify-content-between mt-2">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={e => {
                  setOpenedOrder(null)
                  setShowModalNota(false)
                }}
              >
                Cancelar
              </button>

              <button type="submit" className="btn btn-primary">
                Enviar
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={novaSolicitacao}
        centered
        size="xl"
        toggle={() => {
          setNovaSolicitacao(!novaSolicitacao)
        }}
      >
        <ModalHeader>
          Abertura de Chamado
          <button
            type="button"
            onClick={() => {
              setNovaSolicitacao(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody style={{ minHeight: 300 }} className="card mb-0">
          {/* <Card> */}
          <CardBody>
            <Row>
              <Col>
                <FormGroup style={{ paddingLeft: "0px" }}>
                  <Label>{t("Canal de Atendimento")}</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    required
                    value={canalAtendimento}
                    options={canalAtendimetoOptions}
                    placeholder="Canal de Atendimento"
                    onChange={e => {
                      channelRef.current = e
                      setCanalAtendimento(e)
                    }}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup style={{ paddingLeft: "0px" }}>
                  <Label>{t("Tipo de Chamado")}</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    required
                    value={tipoChamado}
                    options={typesOptions.filter(
                      e =>
                        e.canShow === true &&
                        (e.shippingCompanyId === null ||
                          e.shippingCompanyId === order.shippingCompanyId)
                    )}
                    placeholder="Tipo de Chamado"
                    onChange={e => {
                      setTipoChamado(e)
                      setQueues(e.queues)
                      setSelectedForm(e.form)
                      setSupport(e.value)
                    }}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup style={{ paddingLeft: "0px" }}>
                  <Label>{t("Fila de Atendimento")}</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    required
                    // ref={novaQueueRef}
                    value={filaAtendimento}
                    options={filaAtendimetoOptions.filter(f => {
                      return queues?.includes(f.value)
                    })}
                    placeholder="Fila de Atendimento"
                    onChange={e => {
                      filalRef.current = e
                      setFilaAtendimento(e)
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={2}>
                <fieldset disabled>
                  <FormGroup style={{ paddingLeft: "0px" }}>
                    <Label>{t("AR")}</Label>
                    <Input
                      name="AR"
                      className="form-control-sm"
                      value={currentOrder.shippingTrackerCode}
                      readOnly
                    />
                  </FormGroup>
                </fieldset>
              </Col>
              <Col sm={2}>
                <fieldset disabled>
                  <FormGroup style={{ paddingLeft: "0px" }}>
                    <Label>{t("Contrato")}</Label>
                    <Input
                      name="accountId"
                      className="form-control-sm"
                      value={currentOrder.accountId}
                      readOnly
                    />
                  </FormGroup>
                </fieldset>
              </Col>
              <Col sm={2}>
                <fieldset disabled>
                  <FormGroup style={{ paddingLeft: "0px" }}>
                    <Label>{t("Transportadora")}</Label>
                    <Input
                      name="shippingCompany"
                      className="form-control-sm"
                      value={currentOrder.shippingCompany.name}
                      readOnly
                    />
                  </FormGroup>
                </fieldset>
              </Col>
              <Col sm={6}>
                <fieldset disabled>
                  <FormGroup style={{ paddingLeft: "0px" }}>
                    <Label>{t("Empresa")}</Label>
                    <Input
                      name="cliente"
                      className="form-control-sm"
                      value={currentOrder.nameCompany}
                      readOnly
                    />
                  </FormGroup>
                </fieldset>
              </Col>

              <Col sm={4}>
                <fieldset disabled>
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Interlocotor</th>
                        <th>Telefone</th>
                      </tr>
                    </thead>
                    <tbody className="form-control-sm">
                      {currentOrder?.interlocutor && (
                        <tr>
                          <td>{currentOrder?.interlocutor}</td>
                          <td>
                            {formatPhoneNumber(currentOrder?.interlocutorPhone)}
                          </td>
                        </tr>
                      )}
                      {order?.interlocutor2 && (
                        <tr>
                          <td>{currentOrder?.interlocutor2}</td>
                          <td>
                            {formatPhoneNumber(
                              currentOrder?.interlocutorPhone2
                            )}
                          </td>
                        </tr>
                      )}
                      {order?.interlocutor3 && (
                        <tr>
                          <td>{currentOrder?.interlocutor3}</td>
                          <td>
                            {formatPhoneNumber(
                              currentOrder?.interlocutorPhone3
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </fieldset>
              </Col>

              <Col sm={8}>
                <fieldset disabled>
                  <FormGroup style={{ paddingLeft: "0px" }}>
                    <Label>{t("Endereço")}</Label>
                    <Input
                      name="shippingStreet"
                      className="form-control-sm"
                      value={
                        closedRequestAnnotations
                          ? `${closedRequestAnnotations?.street}, ${
                              closedRequestAnnotations?.number || ""
                            }, ${
                              closedRequestAnnotations?.complement || ""
                            } - ${closedRequestAnnotations?.neighborhood} - ${
                              closedRequestAnnotations?.city
                            }, ${closedRequestAnnotations?.state} - ${
                              closedRequestAnnotations?.postcode
                            }`
                          : `${currentOrder?.shippingStreet}, ${
                              currentOrder?.shippingStreetNumber || ""
                            }, ${
                              currentOrder?.shippingAddressComplement || ""
                            } - ${currentOrder?.shippingNeighborhood} - ${
                              currentOrder?.shippingCity
                            }, ${currentOrder?.shippingState} - ${
                              currentOrder?.shippingPostcode
                            }`
                      }
                      readOnly
                    />
                  </FormGroup>
                </fieldset>
              </Col>
            </Row>
            {isRequestLoading && (
              <div className="text-center">
                <FontAwesomeIcon icon={faCircleNotch} spin size="3x" />
                <div>Enviando solicitação...</div>
              </div>
            )}
            {selectedForm}
          </CardBody>
          {/* </Card> */}
        </ModalBody>
      </Modal>
      {activeRequest && (
        <ChamadosModal
          setActiveRequest={setActiveRequest}
          activeRequest={activeRequest}
          currentOrder={currentOrder}
        ></ChamadosModal>
      )}
    </React.Fragment>
  )
}

export default withTranslation()(DetalhesAtendimento)
